/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, CompanyID, isEmpty, isEmail, isSingleSelect, passwordChar } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "user";
var moduleName = "Users";
var modulePath = "/clientpanel/users";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      postdata: {
        companyUserFirstname: "",
        companyUserEmail: "",
        companyLoginUserName: "",
        companyUserPassword: "",
        cpassword: "",
        companyUserOutletID: "",
        companyUserStatus: "",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
      outletList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${apiUrl}${module}/details/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost != nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message ?? "";
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.navigate(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var companyUserStatus = result.companyUserStatus == "A" ? "Active" : "Inactive";
          var companyUserStatus =
            result.companyUserStatus !== "" && result.companyUserStatus !== null
              ? {
                  label: companyUserStatus,
                  value: result.companyUserStatus,
                }
              : "";
          var clientupdatedata = {
            companyUserFirstname: result.companyUserFirstname,
            companyLoginUserName: result.companyLoginUserName,
            companyUserEmail: result.companyUserEmail,
            companyUserPassword: "",
            cpassword: "",
            companyUserOutletID: result.companyUserOutletID !== null ? { label: result.outletName, value: result.companyUserOutletID } : { label: "Select Outlet", value: "" },
            companyUserStatus: companyUserStatus,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  loadOutlet() {
    var urlShringTxt = apiUrl + "outlet/dropdown?company_id=" + CompanyID();
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          var result = [{ label: "Select Outlet", value: "" }];
          res.data.result.map((item) => {
            result.push(item);
          });
          this.setState({ outletList: result });
        }
      })
      .catch(() => {});
  }

  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      companyUserFirstname: postData.companyUserFirstname,
      companyUserPassword: postData.companyUserPassword,
      companyUserEmail: postData.companyUserEmail,
      companyUserOutletID: postData.companyUserOutletID?.value || "",
      companyUserStatus: postData.companyUserStatus?.value || "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    } else {
      postObject["companyLoginUserName"] = postData.companyLoginUserName;
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"users"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>

                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  outletList={this.state.outletList}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

const minLength = (password, length) => (password.length >= length || password === "" ? null : `Password must be at least ${length} characters.`);
const areSame = (password, rePassword) => (password === rePassword ? null : "Password do not match.");

function validationConfig(props) {
  const { companyUserFirstname, companyLoginUserName, companyUserPassword, cpassword, companyUserEmail, companyUserOutletID, companyUserStatus } = props.fields;
  if (props.fields.action === "add") {
    return {
      fields: ["companyUserFirstname", "companyLoginUserName", "companyUserPassword", "cpassword", "companyUserEmail", "companyUserOutletID", "companyUserStatus"],

      validations: {
        companyUserFirstname: [[isEmpty, companyUserFirstname]],
        companyLoginUserName: [[isEmpty, companyLoginUserName]],
        companyUserPassword: [
          [isEmpty, companyUserPassword],
          [minLength, companyUserPassword, 8],
          [passwordChar, companyUserPassword],
        ],
        cpassword: {
          rules: [
            [areSame, companyUserPassword, cpassword],
            [isEmpty, cpassword],
          ],
          fields: ["companyUserPassword", "cpassword"],
        },
        companyUserEmail: [
          [isEmpty, companyUserEmail],
          [isEmail, companyUserEmail],
        ],
        companyUserOutletID: [[isSingleSelect, companyUserOutletID]],
        companyUserStatus: [[isSingleSelect, companyUserStatus]],
      },
    };
  } else {
    return {
      fields: ["companyUserFirstname", "companyLoginUserName", "companyUserPassword", "cpassword", "companyUserEmail", "companyUserOutletID", "companyUserStatus"],

      validations: {
        companyUserFirstname: [[isEmpty, companyUserFirstname]],
        companyLoginUserName: [[isEmpty, companyLoginUserName]],
        companyUserPassword: [
          [minLength, companyUserPassword, 8],
          [passwordChar, companyUserPassword],
        ],
        cpassword: {
          rules: [[areSame, companyUserPassword, cpassword]],
          fields: ["companyUserPassword", "cpassword"],
        },
        companyUserEmail: [
          [isEmpty, companyUserEmail],
          /*  [isEmail, companyUserEmail], */
        ],
        companyUserOutletID: [[isSingleSelect, companyUserOutletID]],
        companyUserStatus: [[isSingleSelect, companyUserStatus]],
      },
    };
  }
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgName,
      errMsgUserName,
      errMsgPassword,
      errMsgConfirmPassword,
      errMsgEmail,
      errMsgOutlet,
      errMsgStatus = "";
    if ($validation.companyUserFirstname.error.reason !== undefined) {
      errMsgName = $validation.companyUserFirstname.show && <span className="error">{$validation.companyUserFirstname.error.reason}</span>;
    }
    if ($validation.companyLoginUserName.error.reason !== undefined) {
      errMsgUserName = $validation.companyLoginUserName.show && <span className="error">{$validation.companyLoginUserName.error.reason}</span>;
    }
    if (this.props.fields.action === "add") {
      if ($validation.companyUserPassword.error.reason !== undefined) {
        errMsgPassword = $validation.companyUserPassword.show && <span className="error">{$validation.companyUserPassword.error.reason}</span>;
      }
      if ($validation.cpassword.error.reason !== undefined) {
        errMsgConfirmPassword = $validation.cpassword.show && <span className="error">{$validation.cpassword.error.reason}</span>;
      }
    }
    if ($validation.companyUserEmail.error.reason !== undefined) {
      errMsgEmail = $validation.companyUserEmail.show && <span className="error">{$validation.companyUserEmail.error.reason}</span>;
    }
    if ($validation.companyUserOutletID.error.reason !== undefined) {
      errMsgOutlet = $validation.companyUserOutletID.show && <span className="error">{$validation.companyUserOutletID.error.reason}</span>;
    }
    if ($validation.companyUserStatus.error.reason !== undefined) {
      errMsgStatus = $validation.companyUserStatus.show && <span className="error">{$validation.companyUserStatus.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgName !== "" && errMsgName !== false && errMsgName !== undefined ? "form-control is-invalid" : "form-control"}
                name="companyUserFirstname"
                value={fields.companyUserFirstname}
                {...$field("companyUserFirstname", (e) => onChange("companyUserFirstname", e.target.value))}
              />
              <label htmlFor="companyUserFirstname">
                Name <span className="error">*</span>
              </label>
              {errMsgName}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgEmail !== "" && errMsgEmail !== false && errMsgEmail !== undefined ? "form-control is-invalid" : "form-control"}
                name="companyUserEmail"
                value={fields.companyUserEmail}
                {...$field("companyUserEmail", (e) => onChange("companyUserEmail", e.target.value))}
              />
              <label htmlFor="companyUserEmail">
                Email ID <span className="error">*</span>
              </label>
              {errMsgEmail}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgUserName !== "" && errMsgUserName !== false && errMsgUserName !== undefined ? "form-control is-invalid" : "form-control"}
                name="companyLoginUserName"
                readOnly={fields.action === "edit" ? true : false}
                disabled={fields.action === "edit" ? true : false}
                value={fields.companyLoginUserName}
                {...$field("companyLoginUserName", (e) => onChange("companyLoginUserName", e.target.value))}
              />
              <label htmlFor="companyLoginUserName">
                Username <span className="error">*</span>
              </label>
              {errMsgUserName}
            </div>
          </div>

          <div className="col-md-6">
            <div className="mb-4 form-password-toggle">
              <div className="input-group input-group-merge">
                <div className="form-floating form-floating-outline">
                  <input
                    type="password"
                    id="companyUserPassword"
                    className={errMsgPassword !== "" && errMsgPassword !== false && errMsgPassword !== undefined ? "form-control is-invalid" : "form-control"}
                    value={fields.companyUserPassword}
                    {...$field("companyUserPassword", (e) => onChange("companyUserPassword", e.target.value))}
                  />
                  <label htmlFor="companyUserPassword">
                    Password <span className="error">*</span>
                  </label>
                  {errMsgPassword}
                </div>
                <span className="input-group-text rounded-end cursor-pointer" id="basic-default-password4" style={{ height: "49px" }}>
                  <i className="mdi mdi-eye-off-outline"></i>
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-4 form-password-toggle">
              <div className="input-group input-group-merge">
                <div className="form-floating form-floating-outline">
                  <input
                    type="password"
                    id="cpassword"
                    className={errMsgConfirmPassword !== "" && errMsgConfirmPassword !== false && errMsgConfirmPassword !== undefined ? "form-control is-invalid" : "form-control"}
                    value={fields.cpassword}
                    {...$field("cpassword", (e) => onChange("cpassword", e.target.value))}
                  />
                  <label htmlFor="cpassword">
                    Confirm Password <span className="error">*</span>
                  </label>
                  {errMsgConfirmPassword}
                </div>
                <span className="input-group-text rounded-end cursor-pointer" id="basic-default-password3" style={{ height: "49px" }}>
                  <i className="mdi mdi-eye-off-outline"></i>
                </span>
              </div>
            </div>
          </div>
          <div className={errMsgOutlet !== "" && errMsgOutlet !== false && errMsgOutlet !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.companyUserOutletID}
                onChange={this.handleSelectChange.bind(this, "companyUserOutletID")}
                placeholder={"Select Outlet"}
                options={this.props.outletList}
                isClearable={true}
              />
              <label className="select-box-label">
                Outlet<span className="error">*</span>
              </label>
              {errMsgOutlet}
            </div>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.companyUserStatus}
                onChange={this.handleSelectChange.bind(this, "companyUserStatus")}
                placeholder="Select Status *"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
